<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <nte-request>
        </nte-request> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import nteRequest from './todo-nte-request'
export default {
    components: {
        nteRequest
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-nte-request.vue